import { createStyles } from 'antd-style';
export var useStyles = createStyles(function () {
  return {
    container: {
      '& .ant-pro-steps-form-step': {
        marginBlockStart: 0
      },
      '& .ant-pro-steps-form': {
        '& > .ant-row': {
          display: 'unset',
          marginLeft: 'unset !important',
          marginRight: 'unset !important',
          '& > .ant-col': {
            padding: '0 !important'
          }
        }
      },
      '& .ant-pro-steps-form-steps-container': {
        '& .ant-steps-item-container': {
          display: 'flex',
          flexDirection: 'row-reverse'
        },
        '& .ant-steps-item-tail': {
          marginLeft: '82px !important'
        },
        '& .ant-steps-item-active .ant-steps-icon-dot': {
          marginLeft: '2px'
        }
      },
      '& .ant-pro-footer-bar': {
        backgroundColor: '#FFFFFF'
      },
      '& .ant-pro-steps-form-container': {
        '& > .ant-space': {
          display: 'none'
        }
      }
    }
  };
});